import React from "react"
import ActivityLocationControl from "./ActivityLocationControl"
import { COMPARISONS, PERIODS } from "./queryState"

const SPORTS = [["all", "All sports"], ["tennis", "Tennis"], ["padel", "Padel"]]
const pairs = options => options.map(({ key, label }) => [key, label])

// The Period, Comparison, Sport and Activity Location fields of Extended Analytics, with the options the last snapshot
// offers (the defaults before one arrives). Shared with CP „Tournament feedback” › Analysis, which leaves out the
// periods it does not offer (`hiddenPeriods`). The caller places them in its `analytics-filter-grid`.
export default function AnalyticsFilterFields({ query, snapshot, onChange, hiddenPeriods = [] }) {
  const periodOptions = (snapshot?.availableFilters?.periods ? pairs(snapshot.availableFilters.periods) : PERIODS)
    .filter(([key]) => !hiddenPeriods.includes(key))
  const comparisonOptions = snapshot?.filters?.period === query.period
    ? pairs(snapshot.availableFilters.comparisons)
    : COMPARISONS[query.period]
  const sportOptions = snapshot?.availableFilters?.sports ? pairs(snapshot.availableFilters.sports) : SPORTS
  const select = (key, label, options) => (
    <label>
      <span>{label}</span>
      <select value={query[key]} onChange={event => onChange({ [key]: event.target.value })}>
        {options.map(([optionValue, optionLabel]) => <option value={optionValue} key={optionValue}>{optionLabel}</option>)}
      </select>
    </label>
  )
  return (
    <>
      {select("period", "Period", periodOptions)}
      {select("comparison", "Comparison", comparisonOptions)}
      {select("sport", "Sport", sportOptions)}
      <ActivityLocationControl
        query={query}
        catalog={snapshot?.availableFilters?.activityLocations}
        onChange={onChange}
      />
    </>
  )
}
